// startup
// Load entry module and return exports
// This entry module is referenced by other modules so it can't be inlined
__webpack_require__("./sparta-install-temp/gt-footer-unauth-secure-bofa-widget.1.0.0/node_modules/@sparta.global.modules/global-social-module/dist/es6.js");
__webpack_require__("./sparta-install-temp/gt-footer-unauth-secure-bofa-widget.1.0.0/widget/dist/es6.js");
var __webpack_exports__ = __webpack_require__("./sparta-install-temp/gt-footer-unauth-secure-bofa-widget.1.0.0/node_modules/@sparta.global-tenants.modules/gt-footer-unauth-secure-bofa-module/dist/es6.js");
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
